import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetsApi } from 'src/Services/API';
import { TempUploadedImageDto } from 'src/Services/API/generated';

export const useUploadAssetPhoto = (
  options?: UseMutationOptions<TempUploadedImageDto, unknown, File>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<TempUploadedImageDto, unknown, File>(
    'upload-asset-photo',
    async (file: File) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await assetsApi.assetsControllerUploadTemporaryPhoto(assetId, file);
      return response.data;
    },
    options
  );
};
